/** Serial numbers are printed in capitals; typed input is normalised the same way everywhere. */
export const normalizeSerial = (v: string) => v.toUpperCase();
